const DATA_LAYER_REFONTE_2025 = 'refonte_2025';

const availableParameters = [
    { paramKey: 'event', dataAttribute: 'data-layer-event' },
    { paramKey: 'eventCat', dataAttribute: 'data-layer-event-cat', reset: true },
    { paramKey: 'eventAct', dataAttribute: 'data-layer-event-act', reset: true },
    { paramKey: 'eventLab', dataAttribute: 'data-layer-event-lab', reset: true },
    { paramKey: 'eventContext', dataAttribute: 'data-layer-event-context', reset: true },
    {
        paramKey: 'eventName',
        dataAttribute: 'data-layer-event-name',
        enabledFor: (element) => element.getAttribute('data-layer-event') === DATA_LAYER_REFONTE_2025,
    },
    {
        // Conflict with data layer for "refonte_2025" elements, as "eventType" is used for another purpose.
        // Use data-layer-event-trigger to set the event trigger (click, mouseover, change, etc.).
        // Use data-layer-event-type to set the event type (click, mouseover, change, etc.) for older elements.
        paramKey: 'eventType',
        dataAttribute: 'data-layer-event-type',
        enabledFor: (element) => element.getAttribute('data-layer-event') === DATA_LAYER_REFONTE_2025,
    },
    {
        paramKey: 'eventCat',
        dataAttribute: 'data-layer-event-cat-anonymous',
        enabledFor: (element, user) => !user?.content?.connected,
    },
    {
        paramKey: 'eventCat',
        dataAttribute: 'data-layer-event-cat-authenticated',
        enabledFor: (element, user) => user?.content?.connected,
    },
    {
        paramKey: 'eventContext',
        dataAttribute: 'data-layer-event-context-anonymous',
        enabledFor: (element, user) => !user?.content?.connected,
    },
    {
        paramKey: 'eventContext',
        dataAttribute: 'data-layer-event-context-authenticated',
        enabledFor: (element, user) => user?.content?.connected,
    },
    { paramKey: 'mediaType', dataAttribute: 'data-layer-event-media-type' },
    { paramKey: 'articleType', dataAttribute: 'data-layer-event-article-type' },
    { paramKey: 'blocName', dataAttribute: 'data-layer-event-bloc-name' },
    { paramKey: 'keyword', dataAttribute: 'data-layer-event-keyword' },
    { paramKey: 'offreType', dataAttribute: 'data-layer-event-offre-type' },
    { paramKey: 'offreDate', dataAttribute: 'data-layer-event-offre-date' },
    { paramKey: 'salonName', dataAttribute: 'data-layer-event-salon-name' },
    { paramKey: 'ecoleName', dataAttribute: 'data-layer-event-ecole-name' },
    { paramKey: 'filièreEtude', dataAttribute: 'data-layer-event-filiere-etude' },
    { paramKey: 'secteurEtude', dataAttribute: 'data-layer-event-secteur-etude' },
    { paramKey: 'opsName', dataAttribute: 'data-layer-event-ops-name' },
    { paramKey: 'socialNet', dataAttribute: 'data-layer-event-social-net' },
    { paramKey: 'socialAct', dataAttribute: 'data-layer-event-social-act' },
    { paramKey: 'socialTarget', dataAttribute: 'data-layer-event-social-target' },
    { paramKey: 'registerStep', dataAttribute: 'data-layer-event-register-step' },
    { paramKey: 'userProfile', dataAttribute: 'data-layer-event-register-profile' },
];

const onSiteAdParameters = [
    { paramKey: 'onsitead_type', dataAttribute: 'data-onsitead-type' },
    { paramKey: 'onsitead_campaign', dataAttribute: 'data-onsitead-campaign' },
    { paramKey: 'onsitead_category', dataAttribute: 'data-onsitead-category' },
    { paramKey: 'onsitead_format', dataAttribute: 'data-onsitead-format' },
    { paramKey: 'onsitead_general_placement', dataAttribute: 'data-onsitead-general-placement' },
];

const observers = new WeakMap();

const getEventParameters = (element, sourceParameters = availableParameters) => {
    if (element.tagName === 'SELECT') {
        const selectedItems = [];
        // eslint-disable-next-line no-restricted-syntax
        for (const selectedItem of element.selectedOptions) {
            selectedItems.push(selectedItem.value);
        }

        element.setAttribute('data-layer-event-lab', selectedItems.join(';'));
    }

    const eventParameters = {};
    const user = JSON.parse(sessionStorage.getItem('user'));

    sourceParameters.map((parameter) => {
        if (parameter.reset) {
            eventParameters[parameter.paramKey] = element.getAttribute(parameter.dataAttribute) || '';
        } else if (element.hasAttribute(parameter.dataAttribute) && (parameter.enabledFor?.(element, user) ?? true)) {
            eventParameters[parameter.paramKey] = element.getAttribute(parameter.dataAttribute);

            return;
        }

        // Each available parameter can have a corresponding query selector attribute to fetch value(s) from other elements.
        // Query selector can target multiple elements; in that case, values are joined with "|" character.
        // Example: data-layer-event-lab-query-selector or data-layer-event-act-query-selector.
        if (!element.hasAttribute(`${parameter.dataAttribute}-query-selector`) || !(parameter.enabledFor?.(element, user) ?? true)) {
            return;
        }

        const values = [];
        const targetNodes = document.querySelectorAll(element.getAttribute(`${parameter.dataAttribute}-query-selector`));
        targetNodes.forEach((node) => {
            if (node.tagName === 'INPUT') {
                const label = node.closest('label');

                values.push(label?.innerText ?? node.value);
            } else if (element.tagName === 'SELECT') {
                // eslint-disable-next-line no-restricted-syntax
                for (const selectedItem of element.selectedOptions) {
                    values.push(selectedItem.value);
                }
            }
        });

        if (values.length > 0) {
            eventParameters[parameter.paramKey] = values.join(';');
        }
    });

    // Deprecated attribute "data-layer-event-queryselector". Use "data-layer-event-lab-query-selector" instead.
    if (element.hasAttribute('data-layer-event-queryselector') && !element.hasAttribute('data-layer-event-lab')) {
        const targetNode = document.querySelector(element.getAttribute('data-layer-event-queryselector'));
        let paramName = 'eventLab';
        let paramValue = '';

        if (targetNode !== null) {
            if (targetNode.tagName === 'INPUT') {
                paramValue = targetNode.value;
            } else if (targetNode.tagName === 'H1') {
                paramValue = targetNode.innerText;
            }
        }

        if (element.hasAttribute('data-layer-event-queryselector-param-name')) {
            paramName = element.getAttribute('data-layer-event-queryselector-param-name');
        }

        eventParameters[paramName] = paramValue;
    }

    return eventParameters;
};

const bindOnsiteAdCampaignEvents = (element) => {
    element.addEventListener('click', () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(getEventParameters(element));
        if (element.getAttribute('data-layer-event') !== 'etuEventPromoClick') {
            window.dataLayer.push({ ...getEventParameters(element, onSiteAdParameters), event: 'etuEventPromoClick' });
        }
    });

    const container = element.closest('[id$="-slider"]');

    let observer;
    if (container && observers.has(container)) {
        observer = observers.get(container);
    }

    if (!observer) {
        // use intersection observer to track link visibility
        observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        ...getEventParameters(entry.target, onSiteAdParameters),
                        event: 'etuEventPromoImpression',
                    });

                    observer.unobserve(entry.target);
                }
            });
        }, {
            // trigger when 80% of the element is visible
            threshold: 0.8,
        });

        if (container) {
            observers.set(container, observer);
        }
    }

    observer.observe(element);
};

const trackViewportElements = (element) => {
    const eventParameters = getEventParameters(element);

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push(eventParameters);
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.8,
    });

    observer.observe(element);
};

export default (element) => {
    if (element.hasAttribute('data-onsitead-campaign')) {
        bindOnsiteAdCampaignEvents(element);

        return;
    }

    if (element.hasAttribute('data-track-viewport')) {
        trackViewportElements(element);

        return;
    }

    let triggers = ['click'];
    if (element.getAttribute('data-layer-event') === DATA_LAYER_REFONTE_2025) {
        if (element.hasAttribute('data-layer-event-trigger')) {
            triggers = element.getAttribute('data-layer-event-trigger').split(/\s/).filter(Boolean);
        }
    } else if (element.hasAttribute('data-layer-event-type')) {
        triggers = element.getAttribute('data-layer-event-type').split(/\s/).filter(Boolean);
    }

    triggers.forEach((trigger) => {
        element.addEventListener(trigger, (e) => {
            if ((element.type === 'checkbox' && !element.checked) || (element.tagName === 'DETAILS' && !element.open)) {
                return;
            }
            e.stopPropagation();
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(getEventParameters(element));
        });
    });
};
